import { render, staticRenderFns } from "./SignInMethodPicker.vue?vue&type=template&id=2cfa7e4c&"
import script from "./SignInMethodPicker.vue?vue&type=script&lang=js&"
export * from "./SignInMethodPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports